module.exports = __webpack_public_path__ + "media/images/frontend/covid19-14bb1731e64eb000cf1d5540f127b183.png";